import React,{useEffect} from "react";

import {
  archive_intro,
  archive_features,
  archive_modules,
  archive_release_banner
} from "../../data/archive";
import { news_section } from "../../data/archive-news";

import { signer_headline, signer_features, signer_intro } from "../../data/signer";


import BackgroundHero from "../../components/BackgroundHero/BackgroundHero";
import VerticalTabs from "../../components/VerticalTabs/VerticalTabs";
import SimpleHeadline from "../../components/SimpleHeadline/SimpleHeadline";
import ColumnSection from "../../components/ColumnSection/ColumnSection";
import HeadlineHero from "../../components/HeadlineHero/HeadlineHero";

import { cloud_features_archive, cloud_intro_archive } from "../../data/cloud";

// Para funcionamiento de presentación
import '../Presentation/PresentationView.css';
import ContactUs from '../../components/ContactUs/ContactUs';

const Archive = ({ isPresentation = false,  idPrefix = ""}) => {

  useEffect(() => {
      document.title = archive_intro.title;
    }, []);

  return (
    <>
      <div id={idPrefix + "archive"} className={isPresentation ? "section-snap full-slide" : ""}>
      <BackgroundHero
        sectionId="archive"
        backgroundClass={archive_intro.backgroundClass}
        title={archive_intro.title}
        description={archive_intro.description}
        primaryButton={archive_intro.primaryButton}
        secondaryButton={archive_intro.secondaryButton}
      />
      </div>
      <div id={idPrefix + "release"} className={isPresentation ? "section-snap full-slide" : ""}>
      <HeadlineHero title={archive_release_banner.title} description={archive_release_banner.description} image={archive_release_banner.image} button={archive_release_banner.button} />
      </div>
      <div id={idPrefix + "news"} className={isPresentation ? "section-snap full-slide" : ""}>
      <ColumnSection
        sectionId="news"
        columnCount={news_section.columnCount}
        columns={news_section.columns}
        classNames="text-white glifos-bg-dark-gray"
      />
      </div>
      <div id={idPrefix + "signer_headline"}  className={isPresentation ? "section-snap full-slide" : ""}>
      <SimpleHeadline
        title={signer_headline.title}
        description={signer_headline.description}
        button={signer_headline.button}
      />
      </div>
      <div id={idPrefix + "features"} className={isPresentation ? "section-snap full-slide" : ""}>
      <ColumnSection
        sectionId="features"
        title={archive_features.title}
        backgroundColor={archive_features.backgroundColor}
        columnCount={archive_features.columnCount}
        columns={archive_features.columns}
      />
      </div>
      <div id={idPrefix + "modules"} className={isPresentation ? "section-snap full-slide" : ""}>
      <VerticalTabs
        sectionId="modules"
        sectionTitle="Módulos"
        items={archive_modules}
      />
      </div>
      <div id={idPrefix + "cloud"} className={isPresentation ? "section-snap full-slide" : ""}>
      <BackgroundHero
        sectionId="cloud"
        backgroundClass={cloud_intro_archive.backgroundClass}
        title={cloud_intro_archive.title}
        description={cloud_intro_archive.description}
        primaryButton={cloud_intro_archive.primaryButton}
      />
      </div>
      <div id={idPrefix + "about-cloud"} className={isPresentation ? "section-snap full-slide" : ""}>
      <ColumnSection
        sectionId="about-cloud"
        backgroundColor={cloud_features_archive.backgroundColor}
        columnCount={cloud_features_archive.columnCount}
        columns={cloud_features_archive.columns}
      />
      </div>
      {/*<BackgroundHero
        sectionId="thesis"
        backgroundClass={thesis_intro.backgroundClass}
        title={thesis_intro.title}
        description={thesis_intro.description}
        primaryButton={thesis_intro.primaryButton}
      />
      <ColumnSection
        sectionId="about-thesis"
        backgroundColor={thesis_features.backgroundColor}
        columnCount={thesis_features.columnCount}
        columns={thesis_features.columns}
      />
      <BackgroundHero
        sectionId="glifosforojs"
        backgroundClass={ojs_intro.backgroundClass}
        title={ojs_intro.title}
        description={ojs_intro.description}
        primaryButton={ojs_intro.primaryButton}
      />
      <ColumnSection
        sectionId="about-glifosforojs"
        backgroundColor={ojs_features.backgroundColor}
        columnCount={ojs_features.columnCount}
        columns={ojs_features.columns}
      />*/}
      <div id={idPrefix + "glifos-signer"} className={isPresentation ? "section-snap full-slide" : ""}>
      <BackgroundHero
        sectionId="glifos-signer"
        backgroundClass={signer_intro.backgroundClass}
        title={signer_intro.title}
        description={signer_intro.description}
        primaryButton={signer_intro.primaryButton}
      />
      </div>
      <div id={idPrefix + "about-signer"} className={isPresentation ? "section-snap full-slide" : ""}>
      <ColumnSection
        sectionId="about-signer"
        title={signer_features.title}
        description={signer_features.description}
        columnCount={signer_features.columnCount}
        columns={signer_features.columns}
      />
      </div>
      {isPresentation && (
        <div id={idPrefix + "contactus"} className="section-snap full-slide">
          <ContactUs sectionId="contactus"/>
        </div>
      )}

    </>
  );
};

export default Archive;
